import { ElementPropertyTargetType } from "../properties";
import { z } from "zod";
export const ElementView = z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    name: z.string(),
    description: z.string(),
    targetElementType: ElementPropertyTargetType,
    isDefault: z.boolean(),
});
